// extracted by mini-css-extract-plugin
export default {"container":"user-chat-message_container__oGl-p","message":"user-chat-message_message__qB-hF"};